import { jsx as _jsx } from "react/jsx-runtime";
import { CustomFieldTypeName } from "@air/api/types";
import { useCallback } from "react";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { PublicAssetCustomFieldDateInput } from "~/components/RightPanel/CustomFields/PublicAssetCustomFieldDateInput";
import { PublicAssetCustomFieldPlainTextInputTableCell } from "~/components/RightPanel/CustomFields/PublicAssetCustomFieldPlainTextInputTableCell";
import { PublicAssetCustomFieldSelect } from "~/components/RightPanel/CustomFields/PublicAssetCustomFieldSelect";
import { usePublicCustomFieldsContext } from "~/providers/PublicCustomFieldsProvider";
import { canChangeAssetCustomFields } from "~/utils/permissions/assetPermissions";
import { BaseCustomFieldTableCell } from "./BaseCustomFieldTableCell";
export const PublicAssetCustomFieldTableCell = (param)=>{
    let { clip, customFieldId, customFieldName } = param;
    var _clip_customFields;
    const actualCustomFieldValue = (_clip_customFields = clip.customFields) === null || _clip_customFields === void 0 ? void 0 : _clip_customFields.find((customField)=>customField.id === customFieldId);
    const assignedCustomFieldValue = actualCustomFieldValue;
    const { permissions } = usePublicPermissions();
    const canEditCustomFields = canChangeAssetCustomFields(permissions);
    const { customFields } = usePublicCustomFieldsContext();
    const customField = customFields === null || customFields === void 0 ? void 0 : customFields.find((field)=>field.id === customFieldId);
    const renderEditableCustomField = useCallback((closeEditor)=>{
        if (!customField) return null;
        if (!canEditCustomFields) return null;
        const assetCustomFieldValue = actualCustomFieldValue || {
            ...customField,
            assetId: clip.assetId,
            value: null,
            values: null
        };
        switch(customField.type.title){
            case CustomFieldTypeName.singleSelect:
            case CustomFieldTypeName.multiSelect:
                {
                    return /*#__PURE__*/ _jsx(PublicAssetCustomFieldSelect, {
                        autoFocus: true,
                        assetId: clip.assetId,
                        canEditCustomFields: canEditCustomFields,
                        onOptionsClose: closeEditor,
                        field: assetCustomFieldValue,
                        trackingLocation: "table-cell",
                        className: "bg-grey-1"
                    });
                }
            case CustomFieldTypeName.plainText:
                {
                    return /*#__PURE__*/ _jsx(PublicAssetCustomFieldPlainTextInputTableCell, {
                        assetId: clip.assetId,
                        field: assetCustomFieldValue,
                        closeEditor: closeEditor,
                        trackingLocation: "table-cell"
                    });
                }
            case CustomFieldTypeName.date:
                {
                    return /*#__PURE__*/ _jsx(PublicAssetCustomFieldDateInput, {
                        isEditing: true,
                        assetId: clip.assetId,
                        canEditCustomFields: canEditCustomFields,
                        field: assetCustomFieldValue,
                        onBlur: closeEditor,
                        trackingLocation: "table-cell"
                    });
                }
        }
    }, [
        customField,
        canEditCustomFields,
        actualCustomFieldValue,
        clip.assetId
    ]);
    return /*#__PURE__*/ _jsx(BaseCustomFieldTableCell, {
        customField: customField,
        customFieldId: customFieldId,
        customFieldName: customFieldName,
        assignedCustomFieldValue: assignedCustomFieldValue,
        renderEditableCustomField: canEditCustomFields ? renderEditableCustomField : undefined
    });
};
